<template>
  <div class="row" v-if="loaded">
    <div class="col-lg-6 col-sm-12 col-xs-12">
      <Select v-model="projectDataLocal.headerData.orderingCompany" placeholder="Ordering company" :options="companies" :viewMode="!canEdit" />
    </div>
    <div class="col-lg-6 col-sm-12 col-xs-12 text-position">
      {{ 'Ordering company Address' | i18n }}: {{ addresses[projectDataLocal.headerData.orderingCompany] }}
    </div>
  </div>
</template>

<script>
import api from '../../../../../api/index';
import Notification from '../../../../common/notification';

import Input from '../../../../common/input';
import Select from '../../../../common/select';

export default {
  title: 'HeaderData',
  components: {
    Input,
    Select,
  },
  props: {
    projectData: {
      type: Object,
      default: () => {},
    },
    canEdit: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      companies: [],
      loaded: false,
      addresses: {},
    };
  },
  computed: {
    projectDataLocal: {
      get: function () {
        return this.projectData;
      },
      set: function (value) {
        this.$emit('projectData', value);
      },
    },
  },
  async created() {
    try {
      const companies = await api.commonCompany.get();
      this.companies = companies.map((c) => {
        this.addresses[c.id] = c.address;
        return { value: c.id, text: c.name };
      });
      this.loaded = true;
    } catch (err) {
      Notification({ type: 'error', message: err.message });
    }
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.text-position {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
}
</style>
